<div class="upgrade-license-page-container container">
  <h1 class="mat-h1 color-primary text-small-caps">{{ 'UPGRADE_TODAY' | translate }}</h1>
  <p>
    {{ 'EMAIL_US' | translate }}
    <a href="mailto:sales@retailstat.com?subject=License%20Upgrade" target="_blank">sales&#64;retailstat.com</a>
    {{ 'TO_UNLOCK' | translate }}
  </p>
</div>
